import { useState } from '#imports'

export const CLICKED_PRODUCT_STATE_KEY = 'clickedProductCardData'

export type ClickedProductCardData = {
  listingId: string
  price: string
}

export function useProductClickStore() {
  const clickedProductCardData = useState<ClickedProductCardData | null>(
    CLICKED_PRODUCT_STATE_KEY,
    () => null,
  )

  return (data: ClickedProductCardData) => {
    clickedProductCardData.value = data
  }
}
